<script lang="ts">
  import type {
    SelectedProjects,
    SelectedColors,
    SelectedElements,
    SelectedRandoms,
  } from "$types";
  import { get_pattern } from "$lib/utilities";

  export let project: SelectedProjects[],
    colors: SelectedColors[],
    element: SelectedElements[],
    random: SelectedRandoms[];
</script>

<section>
  <div class="project" style:background-image={get_pattern(0)}>
    <header>Project</header>
    <div class="parameters">
      {#each project as parameter}
        {parameter.projects?.name}
      {/each}
    </div>
  </div>
  <div class="colors" style:background-image={get_pattern(1)}>
    <header>Colors</header>
    <div class="parameters">
      {#each colors as parameter}
        {parameter.colors?.name}
      {/each}
    </div>
  </div>
  <div class="element" style:background-image={get_pattern(2)}>
    <header>Element</header>
    <div class="parameters">
      {#each element as parameter}
        {parameter.elements?.name}
      {/each}
    </div>
  </div>
  <div class="random" style:background-image={get_pattern(3)}>
    <header>Random</header>
    <div class="parameters">
      {#each random as parameter}
        {parameter.randoms?.name}
      {/each}
    </div>
  </div>
</section>

<style>
section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  text-transform: capitalize;
}
section > div {
  padding: 1rem 2rem;
  background: white;
}
section > div header {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
section > div .parameters {
  font-family: Bitter;
  font-weight: bold;
  color: var(--title);
}
section .project {
  border-right: 1px dashed var(--dots);
  border-bottom: 4px solid var(--projects);
}
section .project header {
  color: var(--projects);
}
section .colors {
  border-bottom: 4px solid var(--colors);
}
section .colors header {
  color: var(--colors);
}
section .element {
  border-bottom: 4px solid var(--elements);
  border-right: 1px dashed var(--dots);
}
section .element header {
  color: var(--elements);
}
section .random {
  border-bottom: 4px solid var(--random);
}
section .random header {
  color: var(--random);
}

@media (max-width: 1024px) {
  section > div {
    padding: 1rem;
  }
}
@media (max-width: 600px) {
  section {
    grid-template-columns: 1fr;
  }
  section .project, section .element {
    border-right: none;
  }
}
</style>
